import {
  BarChart,
  type BarSeriesOption,
  CustomChart,
  type CustomSeriesOption,
  LineChart,
  type LineSeriesOption,
  PieChart,
  type PieSeriesOption,
  SankeyChart,
  type SankeySeriesOption,
  TreemapChart,
  type TreemapSeriesOption,
} from 'echarts/charts';
import {
  DataZoomComponent,
  type DataZoomComponentOption,
  GridComponent,
  type GridComponentOption,
  LegendComponent,
  type LegendComponentOption,
  MarkPointComponent,
  TooltipComponent,
  type TooltipComponentOption,
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { LabelLayout, UniversalTransition } from 'echarts/features';
import { SVGRenderer } from 'echarts/renderers';

// Register only what Timely charts use so the bundle stays tree-shaken.
echarts.use([
  SankeyChart,
  TreemapChart,
  BarChart,
  CustomChart,
  DataZoomComponent,
  GridComponent,
  LabelLayout,
  LineChart,
  LegendComponent,
  MarkPointComponent,
  PieChart,
  SVGRenderer,
  TooltipComponent,
  UniversalTransition,
]);

export type ChartOption = echarts.ComposeOption<
  | SankeySeriesOption
  | TreemapSeriesOption
  | BarSeriesOption
  | CustomSeriesOption
  | DataZoomComponentOption
  | GridComponentOption
  | LineSeriesOption
  | LegendComponentOption
  | PieSeriesOption
  | TooltipComponentOption
>;

export { echarts };
